import { AxiosError } from "axios";
import { clientAxiosInstance } from "../../lib/types/swrFetcher";

export const getLockoutStatus = async (email: string) => {
  try {
    // Call local Next.js API route instead of external service
    const url = `/api/user/v2/lockout-status?email=${encodeURIComponent(email)}`;
    const response = await clientAxiosInstance().get(url);

    if (response.status === 200) {
      return { success: true, data: response.data };
    }
  } catch (error: any) {
    console.error(
      "Error getting lockout status:",
      (error as AxiosError).response?.data
    );
    // Return default "not locked" state on error to avoid blocking user
    return {
      success: true,
      data: {
        locked: false,
        permanent: false,
        remainingSeconds: 0,
      },
    };
  }
};
